import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { FailedFlowsScreen } from "../../features/failed-flows/failed-flows-screen";

export function createFailedFlowsRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "failed-flows",
    element: <FailedFlowsScreen dependencies={dependencies} />,
  };
}
